// User service for user-related API calls
import { apiClient } from './apiClient';
import { API_CONFIG } from '../utils/constants';


type EndpointField = keyof typeof API_CONFIG.ENDPOINTS;

export const adminService = {
    count: async (data: any): Promise<any> => {
        try {
            return await apiClient.get<any>(API_CONFIG.ADMIN_ENDPOINTS.COUNT + '?filter_type=' + data);
        } catch (error) {
            throw error;
        }
    }
};

export default adminService;
